import { ChangeDetectorRef, Component, Inject, OnInit } from "@angular/core";
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { AdminService } from "src/app/admin/admin.service";
import { IRfq } from "../../interfaces/Rfq";

interface DialogData {
  data: IRfq;
  currency: string;
}
@Component({
  selector: "app-submit-costing",
  templateUrl: "./submit-costing.component.html",
  styleUrls: ["./submit-costing.component.scss"],
})
export class SubmitCostingComponent implements OnInit {
  modalData;
  bid_selection_id;
  patchValues;
  listofItem: any;
  submitCostingForm: FormGroup;
  technology_name: any;
  currentIndex;
  currentTabIndex: number = 0;
  currency: string = "INR";

  constructor(
    public dialogref: MatDialogRef<SubmitCostingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private adminService: AdminService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private cdref: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.modalData = this.data["data"];
    this.bid_selection_id = this.data["bid_selection_id"];
    this.currency = this.data.currency;
    this.technology_name = this.modalData.technology_name;
    console.log(this.technology_name);
    this.getCostingTemplateData();
    this.getFormList(this.technology_name);
    this.createForm();
    // this.getDynamicForm();
  }

  getCostingTemplateData() {
    this.adminService
      .getVendorOrderItemCostingTemplated(
        this.bid_selection_id,
        this.modalData.id
      )
      .subscribe(
        (res: any) => {
          if (res.status == 200) {
            this.patchValues = res.body;
            this.getDynamicForm();
            this.toastr.success("Cost Updated for the part", "Success");
          }
        },
        (err) => {
          this.toastr.error("Something went wrong", "Error");
          console.log(err);
        }
      );
  }

  createForm() {
    this.submitCostingForm = this.formBuilder.group({
      costing: new FormArray([]),
      total_cost: null,
    });
  }

  close() {
    this.dialogref.close();
  }

  // Function to convert input JSON into database-insertable format
  convertToDatabaseObject(inputJson) {
    // Combine all lists
    const allLists: any[] = [
      ...this.getCNCCostingList,
      ...this.getSheetMetalCostingList,
      ...this.getInjectionModlingCostingList,
      ...this.getStampedMetalCostingList,
      ...this.getMetalCastingList,
      ...this.getExtrudedCostingList,
    ];

    const categoryMapping = {
      "Material Costs": "cat_001",
      "Mold Costs": "cat_002",
      "Tooling Costs": "cat_002_01",
      "Processing Costs": "cat_003",
      "Labor Costs": "cat_004",
      "Overhead Costs": "cat_005",
      "Finishing Costs": "cat_006",
      "Packaging & Shipping Costs": "cat_007",
      "Miscellaneous Costs": "cat_008",
    };

    // Extract unique costs
    Array.from(new Set(allLists)).forEach((item, index) => {
      categoryMapping[item] = "cat" + "_00" + index + 1;
    });

    return inputJson.map((item) => {
      // Use the mapping object to get a consistent category ID
      const categoryId = categoryMapping[item.name] || "unknown_category";
      return {
        category_id: categoryId,
        category: item.name,
        costs: item.costs.map((cost) => ({
          ...cost, // Spread all cost-specific fields
        })),
      };
    });
  }

  submitCost() {
    const costingValue = this.submitCostingForm.controls?.costing?.value;
    const valueForDB = this.convertToDatabaseObject(costingValue);
    this.adminService
      .updateVendorOrderItemCostingTemplated(
        this.bid_selection_id,
        this.modalData.id,
        valueForDB
      )
      .subscribe(
        (res: any) => {
          if (res.status == 200) {
            this.dialogref.close({ data: res.body });
            this.toastr.success("Cost Updated for the part", "Success");
          }
        },
        (err) => {
          this.toastr.error("Something went wrong", "Error");
          console.log(err);
        }
      );
  }

  // dropdown list
  technologyList: any = [
    { id: "1", name: "Stamping" },
    { id: "2", name: "Metal Casting" },
    { id: "3", name: "Aluminium Extrusion" },
    { id: "4", name: "Heavy Fabrication" },
    { id: "5", name: "Forging" },
    { id: "6", name: "Injection Molding" },
    { id: "7", name: "Sheet Metal Fabrication" },
    { id: "8", name: "CNC Machining" },
    { id: "9", name: "Vacuum casting" },
    { id: "10", name: "3D Printing" }, //!: yet to receive proper fields for this technology
  ];

  getCNCCostingList: any = [
    { id: "1", cost: "Material Costs" },
    { id: "2", cost: "Machining Costs" },
    { id: "3", cost: "Labor Costs" },
    { id: "4", cost: "Overhead Costs" },
    { id: "5", cost: "Packaging & Shipping Costs" },
    { id: "6", cost: "Miscellaneous Costs" },
  ];

  getSheetMetalCostingList: any = [
    { id: "1", cost: "Material Costs" },
    { id: "2", cost: "Mold Costs" },
    { id: "3", cost: "Processing Costs" },
    { id: "4", cost: "Labor Costs" },
    { id: "5", cost: "Overhead Costs" },
    { id: "6", cost: "Finishing Costs" },
    { id: "7", cost: "Packaging & Shipping Costs" },
    { id: "8", cost: "Miscellaneous Costs" },
  ];

  getInjectionModlingCostingList: any = [
    { id: "1", cost: "Material Costs" },
    { id: "2", cost: "Mold Costs" },
    { id: "3", cost: "Processing Costs" },
    { id: "4", cost: "Labor Costs" },
    { id: "5", cost: "Overhead Costs" },
    { id: "6", cost: "Finishing Costs" },
    { id: "7", cost: "Packaging & Shipping Costs" },
    { id: "8", cost: "Miscellaneous Costs" },
  ];

  getStampedMetalCostingList: any = [
    { id: "1", cost: "Material Costs" },
    { id: "2", cost: "Tooling Costs" },
    { id: "3", cost: "Processing Costs" },
    { id: "4", cost: "Labor Costs" },
    { id: "5", cost: "Overhead Costs" },
    { id: "6", cost: "Finishing Costs" },
    { id: "7", cost: "Packaging & Shipping Costs" },
    { id: "8", cost: "Miscellaneous Costs" },
  ];

  getMetalCastingList: any = [
    { id: "1", cost: "Material Costs" },
    { id: "2", cost: "Tooling Costs" },
    { id: "3", cost: "Processing Costs" },
    { id: "4", cost: "Labor Costs" },
    { id: "5", cost: "Overhead Costs" },
    { id: "6", cost: "Finishing Costs" },
    { id: "7", cost: "Packaging & Shipping Costs" },
    { id: "8", cost: "Miscellaneous Costs" },
  ];

  getExtrudedCostingList: any = [
    { id: "1", cost: "Material Costs" },
    { id: "2", cost: "Tooling Costs" },
    { id: "3", cost: "Processing Costs" },
    { id: "4", cost: "Labor Costs" },
    { id: "5", cost: "Overhead Costs" },
    { id: "6", cost: "Finishing Costs" },
    { id: "7", cost: "Packaging & Shipping Costs" },
    { id: "8", cost: "Miscellaneous Costs" },
  ];

  getFormList(val) {
    if (val == "CNC Machining" || val == "3D Printing") { //!: OR condition to be removed when proper data is received
      this.listofItem = this.getCNCCostingList;
    } else if (val == "Sheet Metal Fabrication") {
      this.listofItem = this.getSheetMetalCostingList;
    } else if (val == "Injection Molding") {
      this.listofItem = this.getInjectionModlingCostingList;
    } else if (val == "Stamping") {
      this.listofItem = this.getStampedMetalCostingList;
    } else if (val == "Aluminium Extrusion") {
      this.listofItem = this.getExtrudedCostingList;
    } else if (val == "Metal Casting") {
      this.listofItem = this.getMetalCastingList;
    }
  }

  onChangeDropdown(val) {
    this.getFormList(val);
    console.log(val);
    (this.submitCostingForm.controls["costing"] as FormArray).clear();
    this.getDynamicForm();
  }

  getDynamicForm() {
    const costingArray = this.submitCostingForm.get("costing") as FormArray;
    this.listofItem.forEach((item) => {
      costingArray.push(
        this.formBuilder.group({
          id: item.id,
          name: item.cost,
          costs: new FormArray([this.patchFormValues(item, this.patchValues)]),
        })
      );
    });
  }

  initFormArray(item, values = null): any {
    let formGroup;

    if (item.cost === "Material Costs") {
      formGroup = this.formBuilder.group({
        raw_material_qty: 0,
        raw_material_unitcost: 0,
        raw_material_totalcost: 0,
        add_material_qty: 0,
        add_material_unitcost: 0,
        add_material_totalcost: 0,
      });
    } else if (item.cost === "Machining Costs") {
      formGroup = this.formBuilder.group({
        machine_setup_cost: 0,
        machine_setup_totalcost: 0,
        machining_time: 0,
        machining_time_hourly_rate: 0,
        machining_time_totalcost: 0,
        tooling_cost: 0,
        tooling_cost_totalcost: 0,
      });
    } else if (item.cost === "Labor Costs") {
      formGroup = this.formBuilder.group({
        operator_labor_time: 0,
        operator_labor_hourly_rate: 0,
        operator_labor_totalcost: 0,
        quality_control_time: 0,
        quality_control_hourly_rate: 0,
        quality_control_totalcost: 0,
      });
    } else if (item.cost === "Overhead Costs") {
      formGroup = this.formBuilder.group({
        facility_overhead_cost: 0,
        facility_overhead_totalcost: 0,
        utilities_cost: 0,
        utilities_totalcost: 0,
      });
    } else if (item.cost === "Packaging & Shipping Costs") {
      formGroup = this.formBuilder.group({
        packaging_material_cost: 0,
        packaging_material_totalcost: 0,
        shipping_cost: 0,
        shipping_totalcost: 0,
      });
    } else if (item.cost === "Mold Costs") {
      formGroup = this.formBuilder.group({
        pattern_creation_cost: 0,
        pattern_creation_totalcost: 0,
        mold_making_cost: 0,
        mold_making_totalcost: 0,
        mold_maintenance_cost: 0,
        mold_maintenance_totalcost: 0,
      });
    } else if (item.cost === "Processing Costs") {
      formGroup = this.formBuilder.group({
        melting_time: 0,
        melting_hourly_rate: 0,
        melting_totalcost: 0,
        pouring_time: 0,
        pouring_hourly_rate: 0,
        pouring_totalcost: 0,
        cooling_time: 0,
        cooling_hourly_rate: 0,
        cooling_totalcost: 0,
      });
    } else if (item.cost === "Finishing Costs") {
      formGroup = this.formBuilder.group({
        surface_treatment_time: 0,
        surface_treatment_hourly_rate: 0,
        surface_treatment_totalcost: 0,
        heat_treatment_time: 0,
        heat_treatment_hourly_rate: 0,
        heat_treatment_totalcost: 0,
      });
    } else if (item.cost === "Tooling Costs") {
      formGroup = this.formBuilder.group({
        die_design_cost: 0,
        die_design_totalcost: 0,
        die_fabrication_cost: 0,
        die_fabrication_totalcost: 0,
        die_maintenance_cost: 0,
        die_maintenance_totalcost: 0,
      });
    } else if (item.cost === "Miscellaneous Costs") {
      formGroup = this.formBuilder.group({
        miscellaneous_cost: 0,
        miscellaneous_totalcost: 0,
      });
    }

    // Patch values if provided
    if (values) {
      formGroup.patchValue(values);
    }

    return formGroup;
  }

  patchFormValues(item: any, data: any): AbstractControl {
    let detail;
    if(data?.costing_details){
      detail = data?.costing_details.find((detail: any) => {
        return detail.category == item.cost;
      });
    }

    const formGroup = this.initFormArray(item, detail?.costs[0] ?? null);

    return formGroup;
  }

  get getCostingList(): any {
    return this.submitCostingForm.get("costing") as FormArray;
  }

  getsubCostingList(form): any {
    return form.controls.costs.controls;
  }

  calculateTotal(controls, key) {
    if (key == "raw_material") {
      const a = controls.raw_material_qty;
      const b = controls.raw_material_unitcost;
      controls.raw_material_totalcost = a * b;
      return a * b;
    }
    if (key == "additional_material") {
      const a = controls.add_material_qty;
      const b = controls.add_material_unitcost;
      controls.add_material_totalcost = a * b;
      return a * b;
    }
    if (key == "machine_setup") {
      const a = controls.machine_setup_cost;
      controls.machine_setup_totalcost = a;
      return a;
    }

    if (key == "machining_time") {
      const a = controls.machining_time;
      const b = controls.machining_time_hourly_rate;
      controls.machining_time_totalcost = a * b;
      return a * b;
    }
    if (key == "tooling_cost") {
      const a = controls.tooling_cost;
      controls.tooling_cost_totalcost = a;
      return a;
    }

    if (key == "operator_labor") {
      const a = controls.operator_labor_time;
      const b = controls.operator_labor_hourly_rate;
      controls.operator_labor_totalcost = a * b;
      return a * b;
    }

    if (key == "quality_control") {
      const a = controls.quality_control_time;
      const b = controls.quality_control_hourly_rate;
      controls.quality_control_totalcost = a * b;
      return a * b;
    }

    if (key == "facility_overhead") {
      const a = controls.facility_overhead_cost;
      controls.facility_overhead_totalcost = a;
      return a;
    }

    if (key == "utilities") {
      const a = controls.utilities_cost;
      controls.utilities_totalcost = a;
      return a;
    }

    if (key == "packaging_material") {
      const a = controls.packaging_material_cost;
      controls.packaging_material_totalcost = a;
      return a;
    }

    if (key == "shipping") {
      const a = controls.shipping_cost;
      controls.shipping_totalcost = a;
      return a;
    }

    if (key == "pattern_creation") {
      const a = controls.pattern_creation_cost;
      controls.pattern_creation_totalcost = a;
      return a;
    }

    if (key == "mold_making") {
      const a = controls.mold_making_cost;
      controls.mold_making_totalcost = a;
      return a;
    }

    if (key == "mold_maintenance") {
      const a = controls.mold_maintenance_cost;
      controls.mold_maintenance_totalcost = a;
      return a;
    }

    if (key == "melting") {
      const a = controls.melting_time;
      const b = controls.melting_hourly_rate;
      controls.melting_totalcost = a * b;
      return a * b;
    }
    if (key == "pouring") {
      const a = controls.pouring_time;
      const b = controls.pouring_hourly_rate;
      controls.pouring_totalcost = a * b;
      return a * b;
    }
    if (key == "cooling") {
      const a = controls.cooling_time;
      const b = controls.cooling_hourly_rate;
      controls.cooling_totalcost = a * b;
      return a * b;
    }

    if (key == "surface_treatment") {
      const a = controls.surface_treatment_time;
      const b = controls.surface_treatment_hourly_rate;
      controls.surface_treatment_totalcost = a * b;
      return a * b;
    }

    if (key == "heat_treatment") {
      const a = controls.heat_treatment_time;
      const b = controls.heat_treatment_hourly_rate;
      controls.heat_treatment_totalcost = a * b;
      return a * b;
    }

    if (key == "die_design") {
      const a = controls.die_design_cost;
      controls.die_design_totalcost = a;
      return a;
    }

    if (key == "die_fabrication") {
      const a = controls.die_fabrication_cost;
      controls.die_fabrication_totalcost = a;
      return a;
    }

    if (key == "die_maintenance") {
      const a = controls.die_maintenance_cost;
      controls.die_maintenance_totalcost = a;
      return a;
    }

    if (key == "miscellaneous_cost") {
      const a = controls.miscellaneous_cost;
      controls.miscellaneous_totalcost = a;
      return a;
    }
  }

  totalCost() {
    let total_cost = 0;
    let newArray = [];
    let totalValues = [];
    let array = this.submitCostingForm.controls.costing.value;
    for (let data of array) {
      newArray.push(data.costs[0]);
    }
    let object = newArray.reduce((obj, item) => Object.assign(obj, item), {});

    if (object.raw_material_totalcost) {
      totalValues.push(object.raw_material_totalcost);
    }
    if (object.add_material_totalcost) {
      totalValues.push(object.add_material_totalcost);
    }
    if (object.machine_setup_totalcost) {
      totalValues.push(object.machine_setup_totalcost);
    }
    if (object.machining_time_totalcost) {
      totalValues.push(object.machining_time_totalcost);
    }
    if (object.tooling_cost_totalcost) {
      totalValues.push(object.tooling_cost_totalcost);
    }
    if (object.operator_labor_totalcost) {
      totalValues.push(object.operator_labor_totalcost);
    }
    if (object.quality_control_totalcost) {
      totalValues.push(object.quality_control_totalcost);
    }
    if (object.facility_overhead_totalcost) {
      totalValues.push(object.facility_overhead_totalcost);
    }
    if (object.utilities_totalcost) {
      totalValues.push(object.utilities_totalcost);
    }
    if (object.packaging_material_totalcost) {
      totalValues.push(object.packaging_material_totalcost);
    }
    if (object.shipping_totalcost) {
      totalValues.push(object.shipping_totalcost);
    }
    if (object.pattern_creation_totalcost) {
      totalValues.push(object.pattern_creation_totalcost);
    }
    if (object.mold_making_totalcost) {
      totalValues.push(object.mold_making_totalcost);
    }
    if (object.mold_maintenance_totalcost) {
      totalValues.push(object.mold_maintenance_totalcost);
    }
    if (object.melting_totalcost) {
      totalValues.push(object.melting_totalcost);
    }
    if (object.pouring_hourly_rate) {
      totalValues.push(object.pouring_hourly_rate);
    }
    if (object.cooling_totalcost) {
      totalValues.push(object.cooling_totalcost);
    }
    if (object.surface_treatment_totalcost) {
      totalValues.push(object.surface_treatment_totalcost);
    }
    if (object.heat_treatment_totalcost) {
      totalValues.push(object.heat_treatment_totalcost);
    }
    if (object.die_design_totalcost) {
      totalValues.push(object.die_design_totalcost);
    }
    if (object.die_fabrication_totalcost) {
      totalValues.push(object.die_fabrication_totalcost);
    }
    if (object.die_maintenance_totalcost) {
      totalValues.push(object.die_maintenance_totalcost);
    }
    if (object.miscellaneous_totalcost) {
      totalValues.push(object.miscellaneous_totalcost);
    }
    total_cost = totalValues.reduce(
      (accumulator, currentValue) => accumulator + currentValue,
      0
    );
    this.submitCostingForm.controls.total_cost.setValue(total_cost);
    return total_cost;
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }
}
